import { request, requestList, orgBase } from '@/api/http'
import type { CalibrationProposal } from '@/api/types'

export const calibrationApi = {
  ingestOutcome(orgId: string, body: unknown): Promise<unknown> {
    return request(`${orgBase(orgId)}/back-calibration`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
  },
  proposals(orgId: string): Promise<CalibrationProposal[]> {
    return requestList(`${orgBase(orgId)}/back-calibration/proposals`)
  },
  approve(orgId: string, id: string, reviewedBy: string): Promise<{ status: string }> {
    return request(`${orgBase(orgId)}/back-calibration/proposals/${id}/approve`, {
      method: 'POST',
      body: JSON.stringify({ reviewed_by: reviewedBy }),
    })
  },
}
